exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".range-input-boxes{display:flex;flex-wrap:nowrap;justify-content:space-between;align-items:center;margin-top:24px}.range-input-boxes__hyphen{margin:0 8px;width:17px;height:24px;color:#727e82}.range-input-boxes__min input,.range-input-boxes__max input{width:80px;height:40px;background:rgba(0,0,0,0);border:1px solid #727e82;border-radius:4px;text-align:center}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};